import { inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { SelfserviceService } from '@app/external/pages/selfservice/selfservice.service';
import { SelfserviceStore } from '@app/stores/selfserviceStore';

@Injectable({ providedIn: 'root' })
export class SelfserviceGuard implements CanActivateChild {
    private router = inject(Router);
    private selfserviceService = inject(SelfserviceService);
    private selfserviceStore = inject(SelfserviceStore);

    async canActivateChild(
        _route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        const path = state.url.split(/[?#]/, 1)[0].replace(/\/$/, '');
        if (path === '/selfservice') {
            return true;
        }

        await this.selfserviceService.initializeSession(state.url);
        return this.selfserviceStore.organizationSite()
            ? true
            : this.router.createUrlTree(['/selfservice']);
    }
}
